import { Component, ViewEncapsulation, inject } from '@angular/core';
import { catchError, map, of, tap } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HistoryApiService } from '../../../services/history-api.service';
import { HistoryType } from '../../../interfaces/history-type.interface';
import { StatusType } from '../../../interfaces/status-type.interface';
import { HistoryItem } from '../../../interfaces/history-item.interface';
import { DateConstants } from '../../../constants/date.constant';
import { insertIf } from '../../../utilities/array/insertIf';

export interface HistoryDialogData {
  accountId: number;
  status: StatusType;
  historyType: HistoryType;
  title: string;
}

@Component({
  selector: 'si-history-dialog',
  standalone: true,
  imports: [MatTableModule, CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './history-dialog.component.html',
  styleUrl: './history-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class HistoryDialogComponent {
  dialogRef = inject(MatDialogRef<HistoryDialogComponent>);
  data = inject<HistoryDialogData>(MAT_DIALOG_DATA);
  historyApiService = inject(HistoryApiService);

  DateConstants = DateConstants

  dataSource$ = this.historyApiService.getHistory$(this.data.status, this.data.accountId).pipe(
    map((history) => new MatTableDataSource<HistoryItem>(history.filter((item) => item.historyTypeID === this.data.historyType))),
    catchError(() => of(new MatTableDataSource<HistoryItem>([])))
  );

  handleClose() {
    this.dialogRef.close();
  }

  columns: string[] =
    this.data.historyType === HistoryType.Status
      ? [
        ...insertIf(this.data.status === StatusType.OPAAuthorisationStatus, 'organisationName'),
        'from', 'to', 'date', 'author', 'reason',
      ]
      : ['action', 'date', 'author', 'reason'];
}
